"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") {
		for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: () => from[key],
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var dynamicImport_exports = {};
__export(dynamicImport_exports, {
	CHUNK_RETRY_ATTEMPTS: () => CHUNK_RETRY_ATTEMPTS,
	CHUNK_RETRY_DELAY_MS: () => CHUNK_RETRY_DELAY_MS,
	dynamicImport: () => dynamicImport,
	handleSkewError: () => handleSkewError,
	isChunkLoadError: () => isChunkLoadError,
	loadWithRetry: () => loadWithRetry
});
module.exports = __toCommonJS(dynamicImport_exports);
var dynamicImport = function dynamicImport2(path) {
	var reloadOnError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
	console.info(`dynamicImport TODO`, path);
	return Promise.resolve(void 0);
};
var CHUNK_ERROR_PATTERNS = [
	"Failed to fetch dynamically imported module",
	"error loading dynamically imported module",
	"Importing a module script failed",
	"Unable to preload CSS for"
];
function isChunkLoadError(err) {
	var msg = err instanceof Error ? err.message : String(err);
	return CHUNK_ERROR_PATTERNS.some(function(p) {
		return msg.includes(p);
	});
}
function handleSkewError() {
	if (typeof window === "undefined") return false;
	var key = "__one_skew_reload";
	var last = sessionStorage.getItem(key);
	if (!last || Date.now() - Number(last) > 1e4) {
		sessionStorage.setItem(key, String(Date.now()));
		window.location.reload();
		return true;
	}
	return false;
}
var CHUNK_RETRY_ATTEMPTS = 3;
var CHUNK_RETRY_DELAY_MS = 500;
var realDelay = function realDelay2(ms) {
	return new Promise(function(resolve) {
		return setTimeout(resolve, ms);
	});
};
async function loadWithRetry(loader) {
	var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	var _options_attempts, _options_delayMs, _options_delay, _options_onChunkErrorExhausted;
	var attempts = (_options_attempts = options.attempts) !== null && _options_attempts !== void 0 ? _options_attempts : CHUNK_RETRY_ATTEMPTS;
	var delayMs = (_options_delayMs = options.delayMs) !== null && _options_delayMs !== void 0 ? _options_delayMs : CHUNK_RETRY_DELAY_MS;
	var delay = (_options_delay = options.delay) !== null && _options_delay !== void 0 ? _options_delay : realDelay;
	var recover = (_options_onChunkErrorExhausted = options.onChunkErrorExhausted) !== null && _options_onChunkErrorExhausted !== void 0 ? _options_onChunkErrorExhausted : handleSkewError;
	var attempt = async function attempt1(retriesLeft) {
		try {
			return await loader();
		} catch (err) {
			if (retriesLeft > 0) {
				await delay(delayMs);
				return attempt(retriesLeft - 1);
			}
			if (isChunkLoadError(err) && recover()) return new Promise(function() {});
			throw err;
		}
	};
	return attempt(attempts);
}
//# sourceMappingURL=dynamicImport.js.map
